<template>
    <v-row dense class="pl-1 mt-8">
        <v-col cols="3" class="pr-6">
            <select_initiator :selected_initiator="howz_initiatief" field="howz_initiatief" :isClearable="true" @updateData="updateData"/>    
        </v-col>
        <v-col cols="3" class="pr-6">
            <select_gebr :selected_gebr="howz_gebr" field="howz_gebr" label="Assigned to" :isClearable="true" @updateData="updateData"/>    
        </v-col>                                    
        <v-col cols="6" class="pr-6">
            <select_changetypes :selected_wzct="selected_wzct" field="selected_wzct" label="Change type" :isClearable="true" @updateData="updateData"/>    
        </v-col>                                    
    </v-row>
</template>

<script>

import select_gebr from '@/components/ui/selectors/select_gebr.vue'
import select_initiator from '@/components/huov/ui/select_initiator.vue'
import select_changetypes from '@/components/huov/howz/ui/select_changetypes.vue'

export default {
    props: {
        howz_gebr:{
            type: String,
            default: ''
        } ,
        howz_initiatief: {
            type: String,
            default: ''
        },
        selected_wzct: {
            type: Array,
            default: function() { return []; },
        },
    },
    components: {
        select_gebr,
        select_initiator,
        select_changetypes,
    },

    data() {
        return {        
        }
    },
    methods: {
        updateData(data){
            console.log("update data screen_selections", data);
            this.$emit("updateField", data);
        },
    }
}
</script>

<style scoped>
</style>